 const Contact = () => {
    return (
        <div>
            <h1> This is my Contact </h1>
        </div>
    ) ;
 };

 export default Contact;